import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  table: {
    base: {
      display: 'table',
      width: '100%',
      margin: 0,
      padding: 0,
      borderSpacing: 0,
    },
  },

  row: {
    base: {
      margin: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },

    clickable: {
      cursor: 'pointer',

      ':hover': {
        backgroundColor: theme.colors.backgrounds.mainHover,
      },
    },
  },

  cell: {
    base: {
      ...theme.typography.body,
      color: theme.colors.text.normal,
      textAlign: 'left',
      paddingRight: theme.settings.spacing.xLarge,
      paddingLeft: theme.settings.spacing.xLarge,
    },

    head: {
      color: theme.colors.accents.secondary,
      fontWeight: theme.settings.typography.weights.semibold,
    },

    body: {},

    delimit: {
      borderBottom: theme.settings.borders.regular,
    },

    last: {
      borderBottom: 'none',
    },

    sizes: {
      small: {
        paddingTop: theme.settings.spacing.xSmall,
        paddingBottom: theme.settings.spacing.xSmall,
      },

      medium: {
        paddingTop: theme.settings.spacing.medium,
        paddingBottom: theme.settings.spacing.medium,
      },

      large: {
        paddingTop: '25px',
        paddingBottom: '25px',
      },
    },

    align: {
      left: {
        textAlign: 'left',
      },

      center: {
        textAlign: 'center',
      },

      right: {
        textAlign: 'right',
      },
    },
  },
})
